import { Link } from "react-router-dom";
import { Check, ArrowRight, Sparkles, EyeOff, Coffee } from "lucide-react";
import AppointmentForm from "../components/AppointmentForm";
import FAQ from "../components/FAQ";
import TestimonialsSection from "../components/TestimonialsSection";
import CTASection from "../components/CTASection";

export default function Ortodoncia() {
  const faqs = [
    { q: "¿Qué es Invisalign y en qué se diferencia de los brackets?", a: "Invisalign es un sistema de ortodoncia basado en férulas transparentes removibles hechas a medida. A diferencia de los brackets, es prácticamente invisible, más cómodo y no limita tu alimentación ni higiene." },
    { q: "¿Cuánto dura un tratamiento de ortodoncia invisible?", a: "Depende del caso. Los tratamientos suelen durar entre 6 y 18 meses. En la primera visita gratuita te mostraremos el tiempo estimado y el resultado final gracias al escáner 3D." },
    { q: "¿Hay que usar los alineadores todo el día?", a: "Sí, se deben usar 22 horas al día. Solo se retiran para comer y para la higiene dental." },
    { q: "¿Invisalign es más caro que los brackets?", a: "El precio es similar o ligeramente superior, pero la comodidad, estética y calidad de vida durante el tratamiento son incomparables. Ofrecemos financiación sin intereses." },
  ];
  return (
    <div data-testid="ortodoncia-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
                <span className="text-xs font-semibold text-teal-700 uppercase">Ortodoncia invisible · Calafell</span>
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
                Ortodoncia <span className="underline-accent">invisible</span> en Calafell
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed mb-8">
                Alinea tu sonrisa sin que se note. Invisalign es la tecnología más avanzada en ortodoncia:
                férulas transparentes, removibles y completamente personalizadas.
              </p>
              <Link to="/contacto" className="btn-primary" data-testid="ortodoncia-cta-top">
                Primera visita + escáner 3D gratis <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100">
              <h3 className="text-xl font-bold text-slate-900 mb-2">Consigue tu estudio gratuito</h3>
              <p className="text-sm text-slate-600 mb-5">Con escáner intraoral 3D · Sin compromiso</p>
              <AppointmentForm defaultService="Ortodoncia invisible (Invisalign)" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="container-max">
          <div className="max-w-3xl mb-14">
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">¿Por qué Invisalign?</h2>
            <p className="text-lg text-slate-600">La revolución en ortodoncia para adultos y adolescentes.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { icon: EyeOff, title: "Prácticamente invisible", desc: "Nadie notará que llevas ortodoncia." },
              { icon: Coffee, title: "Removible", desc: "Te lo quitas para comer y lavarte los dientes." },
              { icon: Sparkles, title: "Predecible", desc: "Ves el resultado final con escáner 3D antes de empezar." },
            ].map((item, i) => (
              <div key={i} className="bg-teal-50 rounded-3xl p-8" data-testid={`ortodoncia-benefit-${i}`}>
                <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center mb-5">
                  <item.icon className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-slate-50">
        <div className="container-max">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4 leading-tight">Casos que tratamos</h2>
          <p className="text-lg text-slate-600 mb-14 max-w-2xl">
            Invisalign puede corregir prácticamente cualquier maloclusión.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { t: "Apiñamiento", d: "Dientes amontonados" },
              { t: "Diastemas", d: "Espacios entre dientes" },
              { t: "Mordida cruzada", d: "Desalineación maxilar" },
              { t: "Mordida abierta", d: "Dientes que no cierran" },
            ].map((c, i) => (
              <div key={i} className="bg-white rounded-2xl p-6 border border-slate-200 text-center">
                <div className="w-12 h-12 rounded-full bg-teal-100 mx-auto mb-4 flex items-center justify-center">
                  <Check className="w-5 h-5 text-teal-700" />
                </div>
                <h3 className="font-bold text-slate-900 mb-1">{c.t}</h3>
                <p className="text-sm text-slate-600">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsSection limit={3} />
      <FAQ items={faqs} title="Preguntas sobre ortodoncia invisible" />
      <CTASection />
    </div>
  );
}
